import Ajv from 'ajv'
import addFormats from 'ajv-formats'
import addErrors from 'ajv-errors'
import Fr from 'ajv-i18n/localize/fr'
import En from 'ajv-i18n/localize/en'
import * as Strings from '@avcan/utils/string'
import { EN, FR } from '@avcan/constants/locales'

export function create(schema, locale) {
    const ajv = new Ajv({
        coerceTypes: true,
        allErrors: true,
        verbose: true,
        removeAdditional: true,
    })

    addFormats(ajv)
    addErrors(ajv)

    const validate = ajv.compile(schema)

    return function resolve(data) {
        if (validate(data)) {
            return {
                values: data,
                errors: {},
            }
        }

        const translateErrors = ErrorsTranslators.get(locale)

        translateErrors(validate.errors)

        const errors = parseErrorSchema(validate.errors)

        return {
            values: {},
            errors,
        }
    }
}

export function createDefaults(schema) {
    const options = { useDefaults: true }

    return validate(schema, {}, options)
}

export function createValues(schema, values) {
    const options = { coerceTypes: true, removeAdditional: true }

    return validate(schema, values, options)
}
function validate(schema, values, options) {
    const ajv = new Ajv({
        strict: false,
        validateFormats: false,
        ...options,
    })

    ajv.validate(schema, values)

    return values
}

// i18n
const ErrorsTranslators = new Map([
    [EN, En],
    [FR, Fr],
])

// Utils
function parseErrorSchema(errors) {
    if (!Array.isArray(errors)) {
        return OBJECT
    }

    return Object.fromEntries(errors.map(error => getMessageProps(error)))
}
function getMessageProps({ dataPath, keyword, message, params }) {
    if (keyword === 'errorMessage') {
        const [error] = params.errors

        return getMessageProps({ ...error, message, dataPath })
    }

    // TODO Test keyword for getting proper name

    const name = Strings.fromPath([...Strings.toPath(dataPath, '/'), params.missingProperty])

    return [name, { message }]
}
const OBJECT = {}
